// Redux module for currency
const SET_CURRENCY = "currency/SET";
const APP_SETTINGS_FETCH_SUCCESS = "app/settings/FETCH_SUCCESS";

const initialState = {
  selectedCurrency: null,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case APP_SETTINGS_FETCH_SUCCESS:
      // Configure initial state from app settings
      if (!state.selectedCurrency) {
        return {
          ...state,
          selectedCurrency: action.result.default_currency,
        };
      }
      return state;
    case SET_CURRENCY:
      return {
        ...state,
        selectedCurrency: action.currency,
      };
    default:
      return state;
  }
}

export function setCurrency(currency) {
  return {
    type: SET_CURRENCY,
    currency,
  };
}

export function getCurrency(state) {
  return state.currency.selectedCurrency;
}
